import React, { Component } from "react";
import "./styles/styles.css";

import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ContactImage from "./images/Getintouch-cuate.png"; 
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

class Contactus extends Component {
  render() {
    return (
      <div className="contact-container">
        <div className="contact-left">
          <div className="contact-content">
		           <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>
            <h1>Get in Touch If you need help with a project</h1>

           
 </div>
   
        </div>
 <div className="contact-right">
          <img src={ContactImage} alt="Contact" className="contact-image" />
        </div>
<div className="clear"></div>

            <p className="info">
              For any custom requirement or any issues related to the app,
              please contact us.
            </p>

           
       
 <div className="contact-details">
              <div className="contact-row">
                <PhoneIcon className="contact-icon" />
                <a href="tel:9060570007"><span>+91 90605 70007</span></a>
              </div>

              <div className="contact-row">
                <EmailIcon className="contact-icon" />
                <a href="mailto:globalbuzz@globalbuzz.in" title="Global Buzz - Email"><span>globalbuzz@globalbuzz.in</span></a>

              </div>
            </div>
       
      </div>
    );
  }
}

export default Contactus;